import React from 'react';
import CRUDList from '../Common/CRUDList';
import { carriers } from '../../services/api';

const carrierStatuses = { 0: 'Closed', 1: 'Active' };
const carrierStatusColors = { 0: 'badge-danger', 1: 'badge-success' };

function CarrierForm({ formData, setFormData }) {
  return (
    <>
      <div className="form-group">
        <label>Carrier Name *</label>
        <input
          type="text"
          value={formData.carrier_name || ''}
          onChange={(e) => setFormData({ ...formData, carrier_name: e.target.value })}
          required
        />
      </div>

      <div className="form-group">
        <label>Status *</label>
        <select
          value={formData.carrier_status ?? 1}
          onChange={(e) => setFormData({ ...formData, carrier_status: parseInt(e.target.value) })}
          required
        >
          <option value="1">Active</option>
          <option value="0">Closed</option>
        </select>
      </div>

      <div className="form-group">
        <label>IATA Code</label>
        <input
          type="text"
          maxLength={3}
          value={formData.carrier_iata || ''}
          onChange={(e) => setFormData({ ...formData, carrier_iata: e.target.value.toUpperCase() })}
          placeholder="e.g., SU"
        />
      </div>

      <div className="form-group">
        <label>ICAO Code</label>
        <input
          type="text"
          maxLength={3}
          value={formData.carrier_icao || ''}
          onChange={(e) => setFormData({ ...formData, carrier_icao: e.target.value.toUpperCase() })}
          placeholder="e.g., AFL"
        />
      </div>
    </>
  );
}

function CarriersList() {
  return (
    <CRUDList
      title="Carriers"
      api={carriers}
      columns={['ID', 'Carrier Name', 'IATA', 'ICAO', 'Status']}
      FormComponent={CarrierForm}
      defaultFormData={{ carrier_name: '', carrier_status: 1, carrier_iata: '', carrier_icao: '' }}
      useOldStyle={true}
      renderRow={(item) => (
        <>
          <td>{item.carrier_id}</td>
          <td>{item.carrier_name}</td>
          <td>{item.carrier_iata ? <span className="badge badge-info">{item.carrier_iata}</span> : '-'}</td>
          <td>{item.carrier_icao ? <span className="badge badge-info">{item.carrier_icao}</span> : '-'}</td>
          <td>
            <span className={`badge ${carrierStatusColors[item.carrier_status]}`}>
              {carrierStatuses[item.carrier_status]}
            </span>
          </td>
        </>
      )}
    />
  );
}

export default CarriersList;
